<mat-dialog-content>
	<div class="row" #top>
		<rules-of-behavior class="col-lg-12" class="rob-scroll" [readOnly]="true">
		</rules-of-behavior>
	</div>


	<div *ngIf="!isLoading">

		<div class="row">
			<sign-pad [(signatureString)]="signatureString" [required]="true">
			</sign-pad>
		</div>

	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-raised-button [color]="'primary'" (click)="sign()"
		[disabled]="signatureString.length === 0">Confirm</button>
	<button mat-raised-button [color]="'warn'" mat-dialog-close (click)="decline()">Decline</button>
</mat-dialog-actions>